<template>
  <div>
    <v-btn color="primary" small @click="dialog = true"
      >Add New Department</v-btn
    >
    <v-dialog v-model="dialog" width="450" class="ma-auto" persistent>
      <v-card>
        <v-card-title>Add New Department</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Department Name"
              v-model="form.department_name"
              :rules="rules"
            ></v-text-field>
            <v-text-field
              label="Signatory"
              v-model="form.signatory"
              :rules="rules"
            ></v-text-field>
            <v-text-field
              label="Signatory Position"
              v-model="form.signatory_position"
              :rules="rules"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions
          ><v-btn @click="add_dep">Add</v-btn>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      rules: [(v) => !!v || "This field is required"],
      valid: true,
      show_alert: false,
      alert_message: "",
      alert_type: "",
      dialog: false,
      form: {},
    };
  },
  methods: {
    ...mapActions({
      add_department: "department/add_department",
    }),

    async add_dep() {
      if (this.$refs.form.validate()) {
        await this.add_department(this.form);
        alert("Successfully added a new department");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
